var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipSolidHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #b4b4b4;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipSolidHoriz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LayerSolidHoriz"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.29 30.64 46.35 19.39 21.32 10.38 1.25 21.62 26.29 30.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.29 32.43 46.35 21.18 46.35 19.39 26.29 30.64 26.29 32.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.29 32.43 26.29 30.64 1.25 21.62 1.25 23.42 26.29 32.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 46.35,
    y1: 21.19,
    x2: 26.28,
    y2: 32.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.28,
    y1: 32.43,
    x2: 1.25,
    y2: 23.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1.25,
    y1: 21.62,
    x2: 26.28,
    y2: 30.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.28,
    y1: 30.64,
    x2: 46.35,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 46.35,
    y1: 19.39,
    x2: 21.32,
    y2: 10.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 21.32,
    y1: 10.38,
    x2: 1.25,
    y2: 21.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1.25,
    y1: 23.42,
    x2: 1.25,
    y2: 21.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 46.35,
    y1: 19.39,
    x2: 46.35,
    y2: 21.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.28,
    y1: 30.64,
    x2: 26.28,
    y2: 32.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipSolidHoriz);
export default __webpack_public_path__ + "static/media/IconChipSolidHoriz.ebcecd038e3d1e7a120b0715c5ff3602.svg";
export { ForwardRef as ReactComponent };